import { tournaments } from '../../../mocks/tournaments';

export default function TournamentsSection() {
  return (
    <section className="py-20 px-4 bg-gradient-to-r from-[#1a1a1f] via-[#242429] to-[#1a1a1f]">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 animate-on-scroll opacity-0">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Турниры за live-столами</h2>
          <p className="text-gray-400">Актуальные турниры с крупными призовыми фондами</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {tournaments.map((tournament, index) => (
            <div 
              key={tournament.id} 
              className="bg-[#242429] rounded-2xl overflow-hidden hover:shadow-2xl hover:shadow-[#d4af37]/20 transition-all duration-300 animate-on-scroll opacity-0"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="relative h-48">
                <img src={tournament.image} alt={tournament.name} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent"></div>
                <div className="absolute top-4 right-4">
                  <span className={`px-4 py-2 rounded-full text-sm font-bold ${tournament.status === 'active' ? 'bg-[#2ecc71]' : 'bg-[#d4af37]'} text-black`}>
                    {tournament.status === 'active' ? 'Активен' : 'Скоро'}
                  </span>
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-2xl font-bold mb-1">{tournament.name}</h3>
                  <div className="text-[#d4af37] font-semibold">{tournament.casino}</div>
                </div>
              </div>

              <div className="p-6">
                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div className="bg-[#1a1a1f] rounded-xl p-4 text-center">
                    <div className="text-sm text-gray-400 mb-1">Призовой фонд</div>
                    <div className="text-2xl font-bold text-[#d4af37]">{tournament.prizePool}</div>
                  </div>
                  <div className="bg-[#1a1a1f] rounded-xl p-4 text-center">
                    <div className="text-sm text-gray-400 mb-1">Участников</div>
                    <div className="text-2xl font-bold text-[#2ecc71]">{tournament.participants.toLocaleString()}</div>
                  </div>
                </div>

                <div className="space-y-3 mb-6">
                  <div className="flex items-center gap-3">
                    <i className="ri-gamepad-line text-[#d4af37]"></i>
                    <span className="text-gray-300">{tournament.game}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-coin-line text-[#d4af37]"></i>
                    <span className="text-gray-300">Мин. ставка: {tournament.minBet}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-calendar-line text-[#d4af37]"></i>
                    <span className="text-gray-300">{tournament.startDate} - {tournament.endDate}</span>
                  </div>
                </div>

                <button className="w-full bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black font-bold py-3 px-6 rounded-full hover:shadow-lg hover:shadow-[#d4af37]/50 transition-all duration-300 whitespace-nowrap">
                  Участвовать
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}